import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { HttpBase } from 'app/services/http-base.service';
import {ModuleTableName} from "../shared/models/module-table-name";
import {ExportExcelColumn} from "../shared/models/export-excel-column";


@Injectable()
export class ExcelWorkService extends HttpBase {
    constructor(http: HttpClient, router: Router, translateService: TranslateService) {
        super(http, router, translateService);
    }

    //# download excel
    downloadReport = (columns: ExportExcelColumn[], mainRows: any[], metaData: string[], columnsSpan: string[], culture: string,
                           mainRowsSheetName: string, descriptionCode: string, tablesSettings: ModuleTableName[], fresh: number, title: string, grouping: string[]): Observable<Blob> =>{

        return this.downloadFullReport(columns, mainRows, null, metaData, columnsSpan, culture, mainRowsSheetName,
            null, descriptionCode, tablesSettings, fresh, title, grouping)
    }

    downloadFullReport = (columns: ExportExcelColumn[], mainRows: any[], treeRows: any[], metaData: string[],
                          columnsSpan: string[], culture: string, mainRowsSheetName: string, treeRowsSheetName: string,
                          descriptionCode: string, tablesSettings: ModuleTableName[], fresh: number, title: string, grouping: string[]
    ): Observable<Blob> =>{
        // console.log(mainRows, columnsSpan)
        return this.post<Blob>('/api/excel/downloadexcel', {
            data: [{
                columns,
                mainRows,
                treeRows,
                metaData,
                columnsSpan,
                culture,
                mainRowsSheetName,
                treeRowsSheetName,
                descriptionCode,
                tablesSettings,
                fresh,
                title,
                grouping
            }]
        }, {responseType: 'blob'});
    }

    //# send excel to email
    sendReport = (sku: string, warehouseCode: string, columns: ExportExcelColumn[],
                       mainRows: any[],  metaData: string[], columnsSpan: string[], culture: string, mainRowsSheetName: string, descriptionCode: string,
                       tablesSettings: ModuleTableName[], fresh: number, title: string, grouping: string[], filename: string
    ): Observable<{ success: boolean }> =>{
        return this.sendFullReport(sku, warehouseCode, columns, mainRows, null, metaData, columnsSpan, culture,
            mainRowsSheetName, null, descriptionCode, tablesSettings, fresh, title, grouping, filename)
    }

    sendFullReport = (sku: string, warehouseCode: string, columns: ExportExcelColumn[],
                  mainRows: any[], treeRows: any[],  metaData: string[], columnsSpan: string[], culture: string,
                      mainRowsSheetName: string, treeRowsSheetName: string, descriptionCode: string,
                  tablesSettings: ModuleTableName[], fresh: number, title: string, grouping: string[], filename: string
    ): Observable<{ success: boolean }> =>{
        return this.post<{ success: boolean }>('/api/excel/sendexcel', {
            data: [{
                sku,
                warehouseCode,
                columns,
                mainRows,
                treeRows,
                metaData,
                columnsSpan,
                culture,
                mainRowsSheetName,
                treeRowsSheetName,
                descriptionCode,
                tablesSettings,
                fresh,
                title,
                grouping
            }],
            fileName: filename
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/excel-work.service.ts